export function getLightColour() {
  for (let i = 0; i < window.BRANDS.length; i++) {
    if (window.location.pathname.startsWith(window.BRANDS[i].path)) {
      return window.BRANDS[i].lightColour;
    }
  }
  return "#DFEED2";
}

export function getDarkColour() {
  for (let i = 0; i < window.BRANDS.length; i++) {
    if (window.location.pathname.startsWith(window.BRANDS[i].path)) {
      return window.BRANDS[i].darkColour;
    }
  }
  return "#0EA47A";
}

export function hasHeader() {
  for (let i = 0; i < window.BRANDS.length; i++) {
    if (window.location.pathname.startsWith(window.BRANDS[i].path)) {
      return window.BRANDS[i].hasHeader;
    }
  }
  return true;
}

export function getTitle() {
  for (let i = 0; i < window.BRANDS.length; i++) {
    if (window.location.pathname.startsWith(window.BRANDS[i].path)) {
      return window.BRANDS[i].title;
    }
  }
  return "Alberta Energy Services";
}

export function getIcon() {
  for (let i = 0; i < window.BRANDS.length; i++) {
    if (window.location.pathname.startsWith(window.BRANDS[i].path)) {
      return window.BRANDS[i].icon;
    }
  }
  return "enermetrics.svg";
}

export function getLink() {
  for (let i = 0; i < window.BRANDS.length; i++) {
    if (window.location.pathname.startsWith(window.BRANDS[i].path)) {
      return window.BRANDS[i].link;
    }
  }
  return "https://www.enermetrics.ca";
}

export function getColours() {
  for (let i = 0; i < window.BRANDS.length; i++) {
    if (window.location.pathname.startsWith(window.BRANDS[i].path)) {
      return window.BRANDS[i].colours;
    }
  }
  return window.FALL_COLOURS;
}
